<template>
    <div class="container">
        <router-view name="steps"/>
        <router-view/>
        <router-view name="nav"/>
    </div>
</template>

<script>
import store from '../store/index'

export default {
    name: "Setup",
    beforeRouteEnter(to, from, next) {
        if (to.meta.requiresAddress && !store.getters["setup/hasAddress"]) {
            next({name: 'Home'})
        } else {
            next()
        }
    }
}
</script>
